<div class="wrapper-pages">
  <gr-landing-header *ngIf="!authHelperService.isAuthenticated && activePageHelper.activePage?.showHeader"></gr-landing-header>
  <gr-side-menu *ngIf="activePageHelper?.activePage?.showSideMenu"></gr-side-menu>
  <router-outlet></router-outlet>
  <gr-landing-footer *ngIf="!authHelperService.isAuthenticated && activePageHelper.activePage?.showFooter"></gr-landing-footer>
</div>
<div class="wrapper-screen-size-page">
  <div class="content-screen-size-page">
    <img class="logo-screen-size" src="../assets/images/logo.svg" alt="">
    <div class="content-screen-size">
      <img class="screen-illustration" src="../assets/images/screen-size-icon.svg" alt="">
      <span class="title-text-screen">Ova veličina ekrana nije podržana.</span>
      <span class="subtitle-text-screen">Molimo preuzmite mobilnu aplikaciju Moj Rođendan</span>
      <div class="wrapper-btn-store">
        <a href="">
          <img src="../assets/images/btn-app-store.png" alt="">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app" target="_blank">
          <img src="../assets/images/btn-play-store.png" alt="">
        </a>
      </div>
    </div>
  </div>
</div>
